<router-outlet></router-outlet>
<!-- <div class="container text-center">
  <br><br><br><br><br>
  <h2>Torreon Market se está actualizando...</h2><br>
  <img src="../assets/img/logo.png" width="200" alt="">
</div> -->
